/**
 * No-cook recipes - Just combine, no cleanup
 * ~15 recipes for when you can't face cooking
 */

const NO_COOK_RECIPES = [
  {
    id: 'ham-cheese-sandwich',
    name: 'Ham & Cheese Sandwich',
    effort: 'no-cook',
    needs: ['bread', 'ham', 'cheese'],
    optional: ['lettuce', 'tomato', 'mayo'],
    description: 'Classic sandwich, ready in 2 minutes',
    tips: 'Toast the bread if you want it warm'
  },
  {
    id: 'peanut-butter-banana',
    name: 'PB & Banana Sandwich',
    effort: 'no-cook',
    needs: ['bread', 'peanut butter', 'banana'],
    optional: ['honey'],
    description: 'Sweet and filling, great for energy',
    tips: 'Add honey drizzle for extra sweetness'
  },
  {
    id: 'tuna-mayo-sandwich',
    name: 'Tuna Mayo Sandwich',
    effort: 'no-cook',
    needs: ['bread', 'tuna', 'mayo'],
    optional: ['lettuce', 'cucumber', 'onion'],
    description: 'Protein-packed and satisfying',
    tips: 'Add a squeeze of lemon if you have it'
  },
  {
    id: 'cheese-crackers',
    name: 'Cheese & Crackers Plate',
    effort: 'no-cook',
    needs: ['crackers', 'cheese'],
    optional: ['grapes', 'apple', 'nuts'],
    description: 'Snack plate that feels like a meal',
    tips: 'Variety of cheese makes it special'
  },
  {
    id: 'yogurt-granola-bowl',
    name: 'Yogurt & Granola Bowl',
    effort: 'no-cook',
    needs: ['yogurt', 'granola'],
    optional: ['berries', 'banana', 'honey'],
    description: 'Quick breakfast or light meal',
    tips: 'Layer ingredients for nice presentation'
  },
  {
    id: 'hummus-veggie-wrap',
    name: 'Hummus Veggie Wrap',
    effort: 'no-cook',
    needs: ['tortilla', 'hummus'],
    optional: ['cucumber', 'tomato', 'lettuce', 'carrot'],
    description: 'Fresh and healthy, no cooking needed',
    tips: 'Warm tortilla in microwave for 10 seconds'
  },
  {
    id: 'caprese-salad',
    name: 'Caprese Salad',
    effort: 'no-cook',
    needs: ['tomato', 'mozzarella'],
    optional: ['basil', 'olive oil', 'balsamic'],
    description: 'Simple Italian classic',
    tips: 'Salt the tomatoes for extra flavor'
  },
  {
    id: 'greek-salad',
    name: 'Greek Salad',
    effort: 'no-cook',
    needs: ['cucumber', 'tomato', 'feta'],
    optional: ['olives', 'onion', 'olive oil'],
    description: 'Refreshing Mediterranean salad',
    tips: 'Big chunks, not finely chopped'
  },
  {
    id: 'smoothie-bowl',
    name: 'Smoothie Bowl',
    effort: 'no-cook',
    needs: ['banana', 'yogurt'],
    optional: ['berries', 'granola', 'honey', 'spinach'],
    description: 'Thick smoothie you eat with a spoon',
    tips: 'Freeze banana for thicker texture'
  },
  {
    id: 'avocado-toast',
    name: 'Avocado Toast',
    effort: 'no-cook',
    needs: ['bread', 'avocado'],
    optional: ['egg', 'tomato', 'salt', 'chili flakes'],
    description: 'Trendy but genuinely good',
    tips: 'Mash with fork, leave it chunky'
  },
  {
    id: 'cottage-cheese-fruit',
    name: 'Cottage Cheese & Fruit',
    effort: 'no-cook',
    needs: ['cottage cheese'],
    optional: ['berries', 'peach', 'honey', 'nuts'],
    description: 'High protein, refreshing snack meal',
    tips: 'Sprinkle cinnamon for warmth'
  },
  {
    id: 'deli-roll-ups',
    name: 'Deli Meat Roll-Ups',
    effort: 'no-cook',
    needs: ['deli meat', 'cheese'],
    optional: ['mustard', 'pickle', 'lettuce'],
    description: 'Low-carb, high-protein snack',
    tips: 'Spread cream cheese inside for richness'
  },
  {
    id: 'overnight-oats',
    name: 'Overnight Oats',
    effort: 'no-cook',
    needs: ['oats', 'milk'],
    optional: ['yogurt', 'berries', 'honey', 'chia seeds'],
    description: 'Prep tonight, eat tomorrow',
    tips: 'Make in a jar for easy transport'
  },
  {
    id: 'bean-salad',
    name: 'Three Bean Salad',
    effort: 'no-cook',
    needs: ['beans'],
    optional: ['onion', 'olive oil', 'vinegar', 'herbs'],
    description: 'Hearty, filling, lasts in fridge',
    tips: 'Rinse canned beans well'
  },
  {
    id: 'bruschetta-simple',
    name: 'Simple Bruschetta',
    effort: 'no-cook',
    needs: ['bread', 'tomato'],
    optional: ['garlic', 'basil', 'olive oil'],
    description: 'Fresh tomato on crusty bread',
    tips: 'Rub raw garlic on bread for flavor'
  },
  // === ADDITIONAL PROTEIN OPTIONS ===
  {
    id: 'chicken-salad-wrap',
    name: 'Chicken Salad Wrap',
    effort: 'no-cook',
    needs: ['tortilla', 'rotisserie chicken', 'mayo'],
    optional: ['lettuce', 'celery', 'grapes'],
    description: 'Creamy chicken salad in a wrap',
    tips: 'Add crunch with celery or nuts'
  },
  {
    id: 'turkey-sandwich',
    name: 'Turkey Sandwich',
    effort: 'no-cook',
    needs: ['bread', 'deli turkey', 'cheese'],
    optional: ['lettuce', 'tomato', 'mayo', 'mustard'],
    description: 'Classic deli sandwich',
    tips: 'Toast for a warm sub'
  },
  {
    id: 'roast-beef-sandwich',
    name: 'Roast Beef Sandwich',
    effort: 'no-cook',
    needs: ['bread', 'roast beef', 'cheese'],
    optional: ['horseradish', 'lettuce', 'onion'],
    description: 'Hearty deli classic',
    tips: 'Horseradish gives it a kick'
  },
  {
    id: 'tofu-salad',
    name: 'Tofu Salad Bowl',
    effort: 'no-cook',
    needs: ['tofu', 'lettuce', 'cucumber'],
    optional: ['carrot', 'sesame oil', 'soy sauce'],
    description: 'Light and protein-rich',
    tips: 'Press tofu for better texture'
  },
  {
    id: 'salmon-bagel',
    name: 'Smoked Salmon Bagel',
    effort: 'no-cook',
    needs: ['bagel', 'smoked salmon', 'cream cheese'],
    optional: ['capers', 'onion', 'lemon'],
    description: 'Luxurious but easy breakfast',
    tips: 'Add everything bagel seasoning'
  }
];

export default NO_COOK_RECIPES;
